// extracted by mini-css-extract-plugin
export default {"card":"f199_PW5v8BcBP9KeVhx"};